// =====================================================
// SCHEMAS: CONTACT
// Description: Schémas de validation Zod pour les contacts
// =====================================================

import { z } from 'zod';

export const createContactSchema = z.object({
  first_name: z.string().min(1, 'Le prénom est requis').max(100, 'Le prénom est trop long'),
  last_name: z.string().min(1, 'Le nom est requis').max(100, 'Le nom est trop long'),
  email: z.string().email('Email invalide'),
  phone: z.string().optional(),
  notes: z.string().optional(),
  product_ids: z.array(z.string().uuid()).optional(),
  school_id: z.string().optional(),
  // Adresse
  address: z.string().optional(),
  city: z.string().optional(),
  postal_code: z.string().optional(),
  country: z.string().optional(),
  // Assignation et origine
  assigned_to: z.string().uuid().optional().or(z.literal('')),
  origin_id: z.string().uuid().optional().or(z.literal('')),
  origin_info: z.string().optional(),
  // Statut étudiant
  is_not_student: z.boolean().optional(),
  socio_professional_category: z.string().optional(),
  // Newsletter
  newsletter_opt_in: z.boolean().optional(),
});

export type CreateContactInput = z.infer<typeof createContactSchema>;

export const updateContactSchema = z.object({
  first_name: z
    .string()
    .min(1, 'Le prénom est requis')
    .max(100, 'Le prénom est trop long')
    .optional(),
  last_name: z.string().min(1, 'Le nom est requis').max(100, 'Le nom est trop long').optional(),
  email: z.string().email('Email invalide').optional(),
  phone: z.string().optional(),
  status: z
    .enum([
      'prospect',
      'pre_registered',
      'bed_downloaded',
      'bed_incomplete',
      'bed_incomplete_payment',
      'bed_complete',
      'cancellation_compliant',
      'cancellation_non_compliant',
      'postponement_compliant',
      'postponement_non_compliant',
      'completed',
    ])
    .optional(),
  origin_id: z.string().uuid().optional(),
  notes: z.string().optional(),
  product_ids: z.array(z.string().uuid()).optional(),
  // Adresse
  address: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  postal_code: z.string().optional().nullable(),
  country: z.string().optional().nullable(),
  // Statut étudiant
  is_not_student: z.boolean().optional(),
  socio_professional_category: z.string().optional().nullable(),
  // Newsletter
  newsletter_opt_in: z.boolean().optional(),
});

export type UpdateContactInput = z.infer<typeof updateContactSchema>;
